import {
	useGetImages
} from "~/composables/imageKit/useGetImages";
import {
	useSupabase
} from "~/composables/supabase/useSupabase";
import type {
	IGiftProvider,
	IWishListItem
} from "~/types/supabase";

export default defineNuxtPlugin( () => {
	onNuxtReady( async () => {
		const {
			getPhotoPageImages,
			getInspirationImages,
			getWeddingPartyPhotos
		} = useGetImages();
		const { getGiftProviders, getWishListItems } = useSupabase();
		const { images } = useDev();
		const { ALLOW_API_CALLS } = globalStores();
		const {
			giftProviders,
			wishListItems,
			homePhotos,
			photoPagePhotos,
			ourStoryPhotos,
			inspirationPhotos,
			weddingPartyPhotos,
			contentLoaded
		} = imageDataStores();

		try {
			const giftProvidersPromise: Promise<IGiftProvider[]> = getGiftProviders();
			const wishListItemsPromise: Promise<IWishListItem[]> = getWishListItems();

			if ( ALLOW_API_CALLS.value ) {
				const photoPagePhotosPromise = getPhotoPageImages();
				const inspirationPromise = getInspirationImages();
				const weddingPartyPromise = getWeddingPartyPhotos();

				const [
					photoPagePhotosResult,
					giftProvidersResult,
					wishListItemsResult,
					inspirationPromiseResult,
					weddingPartyPromiseResult
				] = await Promise.all( [
					photoPagePhotosPromise,
					giftProvidersPromise,
					wishListItemsPromise,
					inspirationPromise,
					weddingPartyPromise
				] );

				photoPagePhotos.value = photoPagePhotosResult;
				giftProviders.value = giftProvidersResult;
				wishListItems.value = wishListItemsResult;
				inspirationPhotos.value = inspirationPromiseResult;
				weddingPartyPhotos.value = weddingPartyPromiseResult;
			} else {
				homePhotos.value = images.value;
				photoPagePhotos.value = images.value;
				ourStoryPhotos.value = images.value;
				inspirationPhotos.value = { suit: images.value, dress: images.value };
				weddingPartyPhotos.value = images.value;

				const [ giftProvidersResult, wishListItemsResult ] = await Promise.all( [ giftProvidersPromise, wishListItemsPromise ] );

				giftProviders.value = giftProvidersResult;
				wishListItems.value = wishListItemsResult;
			}
		} catch ( error ) {
			console.error( "Error loading data: ", error );
			return error;
		} finally {
			contentLoaded.value = true;
		}
	} );
} );